import { format } from 'date-fns';

// expires_at là 'YYYY-MM-DD' thuần; new Date(str) hiểu là UTC nên có thể lệch ngày ở múi giờ âm.
// Sai dạng ra `empty` vì format() ném lỗi trên ngày hỏng, làm sập cả bảng/file xuất.
export const formatYmd = (value?: string | null, empty = '—') => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '');
  if (!match) return empty;
  const [y, m, d] = match.slice(1).map(Number);
  const date = new Date(y, m - 1, d);
  // Date tự "tràn" 2027-02-31 sang tháng 3: coi như sai dạng thay vì hiện ngày khác
  if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return empty;
  return format(date, 'dd/MM/yyyy');
};

// used_at là ISO có múi giờ: hiện theo giờ máy. Ngày hỏng ra '' vì format() ném lỗi,
// một dòng bẩn sẽ làm hỏng cả bảng hoặc cả file xuất 50.000 dòng.
export const formatDateTime = (value?: string | null) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : format(date, 'dd/MM/yyyy HH:mm');
};

export const DELETED_USER = 'Người dùng đã xoá';
